export class FeedbackDTO {

  constructor(
    readonly comment: string,
    readonly userEmail: string,
    readonly screenshot?: File | null,
    public application?: string,
  ) {
  }
}